import { FC } from "react";
import { Amount } from "@design-system/Amount/Amount";
import { SummaryStats } from "@design-system/SummaryStats/SummaryStats";

interface LineItemsFooterStatsProps {
    totalOpenAmount: number;
    totalPaidAmount: number;
    totalAmount: number;
    count: number;
    countLabel: string;
}

export const LineItemsFooterStats: FC<LineItemsFooterStatsProps> = ({
    totalOpenAmount,
    totalPaidAmount,
    totalAmount,
    count,
    countLabel,
}) => (
    <SummaryStats
        trigger={
            <span className="d-block medium text-gray-700">
                Open: <Amount amount={totalOpenAmount} />
            </span>
        }
        sections={[
            [
                {
                    label: "Total open",
                    value: <Amount amount={totalOpenAmount} />,
                },
                {
                    label: "Total paid",
                    value: <Amount amount={totalPaidAmount} />,
                },
            ],
            [{ label: "Total", value: <Amount amount={totalAmount} /> }],
            [{ label: countLabel, value: count }],
        ]}
    />
);
